import React from 'react';
import { getBasePath } from '../../../helper/getBasePath';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { useNavigationHandler } from '../../Header/hooks/useNavigationHandler';

export const LogoTypoSmall: React.FC = () => {
    const { resetNavigation } = useNavigationHandler();

    return (
        <>
            <figure className="relative -top-3 flex h-full items-start justify-start">
                <Link href="/home" onClick={() => resetNavigation()}>
                    <Image
                        className="relative h-full"
                        quality={100}
                        width={130}
                        height={57}
                        objectFit="contain"
                        src={`${getBasePath()}/RE-Europe-2026.svg`}
                        alt="logo RE/MAX Marketing Center"
                        aria-hidden={true}
                    />
                </Link>
            </figure>
        </>
    );
};
